/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type ResponseMCPListToolsInProgressEvent = {
  type: "response.mcp_list_tools.in_progress";
  sequenceNumber: number;
  itemId: string;
  outputIndex: number;
};

/** @internal */
export const ResponseMCPListToolsInProgressEvent$inboundSchema: z.ZodType<
  ResponseMCPListToolsInProgressEvent,
  z.ZodTypeDef,
  unknown
> = z.object({
  type: z.literal("response.mcp_list_tools.in_progress"),
  sequence_number: z.number().int(),
  item_id: z.string(),
  output_index: z.number().int(),
}).transform((v) => {
  return remap$(v, {
    "sequence_number": "sequenceNumber",
    "item_id": "itemId",
    "output_index": "outputIndex",
  });
});
/** @internal */
export type ResponseMCPListToolsInProgressEvent$Outbound = {
  type: "response.mcp_list_tools.in_progress";
  sequence_number: number;
  item_id: string;
  output_index: number;
};

/** @internal */
export const ResponseMCPListToolsInProgressEvent$outboundSchema: z.ZodType<
  ResponseMCPListToolsInProgressEvent$Outbound,
  z.ZodTypeDef,
  ResponseMCPListToolsInProgressEvent
> = z.object({
  type: z.literal("response.mcp_list_tools.in_progress"),
  sequenceNumber: z.number().int(),
  itemId: z.string(),
  outputIndex: z.number().int(),
}).transform((v) => {
  return remap$(v, {
    sequenceNumber: "sequence_number",
    itemId: "item_id",
    outputIndex: "output_index",
  });
});

export function responseMCPListToolsInProgressEventToJSON(
  responseMCPListToolsInProgressEvent: ResponseMCPListToolsInProgressEvent,
): string {
  return JSON.stringify(
    ResponseMCPListToolsInProgressEvent$outboundSchema.parse(
      responseMCPListToolsInProgressEvent,
    ),
  );
}
export function responseMCPListToolsInProgressEventFromJSON(
  jsonString: string,
): SafeParseResult<ResponseMCPListToolsInProgressEvent, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) =>
      ResponseMCPListToolsInProgressEvent$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ResponseMCPListToolsInProgressEvent' from JSON`,
  );
}
